import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tableau",
  "use": "icon-tableau-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-tableau\"><path d=\"M16.4 24v2.6H19v.8h-2.6V30h-.8v-2.6H13v-.8h2.6V24zm6.4-5.8V22h3.8v1h-3.8v3.6h-1V23H18v-1h3.8v-3.8zm-12.6 0V22H14v1h-3.8v3.6h-1V23H5.6v-1h3.6v-3.8zm6.4-6.8v4h4v1.2h-4v4h-1.2v-4h-4v-1.2h4v-4zM27.4 13v2.6H30v.8h-2.6V19h-.8v-2.6H24v-.8h2.6V13zm-22 0v2.6H8v.8H5.4V19h-.8v-2.6H2v-.8h2.6V13zm17.4-8v3.6h3.8v1.2h-3.8v3.6h-1V9.8H18V8.6h3.8V5zM10.2 5v3.6H14v1.2h-3.8v3.6h-1V9.8H5.6V8.6h3.6V5zm6.2-3v2.6H19v.8h-2.6V8h-.8V5.4H13v-.8h2.6V2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol